import { Component, OnInit } from '@angular/core';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}

export const ROUTES: RouteInfo[] = [
  // 1️⃣ DASHBOARD (first)
  { path: '/dashboard', title: 'DASHBORD', icon: 'dashboard', class: '' },

  // 2️⃣ NOUVEAU : Gestion de la page d'accueil
  { path: '/homedesign', title: 'PAGE D\'ACCUEIL', icon: 'home', class: '' },

  // 3️⃣ ADMINISTRATION section
  { path: '/admin', title: 'UTILISATEURS', icon: 'people', class: '' },
  { path: '/admin-requests', title: 'DEMANDES CLIENTS', icon: 'request_page', class: '' },

  // 4️⃣ All other existing menu items (unchanged order)
  { path: '/user-profile', title: 'ADMINS', icon: 'person', class: '' },
  { path: '/nouvelleDemande', title: 'NouvelleDemande', icon: '+', class: '' },
  { path: '/typography', title: 'BANIERE CLIENT', icon: 'library_books', class: '' },
  { path: '/icons', title: 'ADS', icon: 'bubble_chart', class: '' },
  { path: '/listeMagazine', title: 'EDITION MAGAZINE', icon: 'auto_stories', class: '' },
  { path: '/demandeDinscription', title: 'DEMANDE DINSCRIPTION', icon: 'contact_mail', class: '' },
  { path: '/gestionClientèle', title: 'GESTION CLIENTÈLE', icon: 'people', class: '' },
  { path: '/conceptionClient', title: 'DOCUMENTS CLIENTS', icon: 'folder_open', class: '' },
  
  // ✅ EXISTANT : Ancienne annonce (ancienne API)
  { path: '/annonce', title: 'ANNONCE', icon: 'add', class: '' },
  
  // ✅ NOUVEAU : Annonces (nouvelle API)
  { path: '/annoncenew', title: 'ANNONCES (NEW)', icon: 'view_list', class: '' },
  
  { path: '/Materiaux-List', title: 'produits et contact', icon: 'add', class: '' },
  { path: '/List-Promoteurs', title: 'projets et coordonnées', icon: 'add', class: '' },
  { path: 'Liste-agence-immobilier', title: 'projet et coordonnées', icon: 'add', class: '' },
  { path: 'Agences-des-services', title: 'article', icon: 'add', class: '' },
  { path: 'Agences-meilleurs-biens', title: 'Projet et coordonnées', icon: 'add', class: '' },
  { path: 'cafe-resto-liste', title: 'café & coordonnées', icon: 'add', class: '' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }
}